import styled from 'styled-components';
import { Link } from "react-router-dom";

const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flec;
    justify-content: center;
    align-items: center;
`;

const ThanksContainer = styled.div`
    width: 80%;
    height: 50vh;
    background-color: #e82764;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
`;

const ThanksString = styled.span`
    font-size: 40px;
    font-weight: bold;
`;

const Sign = styled.span`
    font-size: 20px;
`;

const LinkStyled = styled(Link)`
    color: white;
    text-decoration: underline;
`;


export {
    Container,
    ThanksContainer,
    ThanksString,
    Sign,
    LinkStyled,
}

